import { FC } from "react";
import { PlatformSettingForm } from "./PlatformSettingForm";

export const AutoFinishSettings: FC = () => (
  <PlatformSettingForm
    name="auto_finish_hours"
    title="Автозавершение заказов в работе"
    label="Часов после начала работ *"
    placeholder="24"
    min={1}
    max={720}
    step={1}
    hint="Заказ в работе (в том числе с переработкой) завершается автоматически через указанное число часов после того, как водитель отметил прибытие на объект. Защита от забытой кнопки «Завершить»: иначе переработка начисляется бесконечно. Проверка идёт раз в минуту, новое значение действует сразу."
  />
);
